import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46b70a88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input__wrapper" }
const _hoisted_2 = ["maxlength", "minlength", "min", "max", "placeholder", "type", "required", "disabled", "step"]
const _hoisted_3 = {
  key: 0,
  class: "input__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass([{ 'input--error': _ctx.errors.length > 0 }, "input"]),
    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showError = true)),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showError = false))
  }, [
    _createElementVNode("span", _hoisted_1, [
      (_ctx.icon)
        ? (_openBlock(), _createBlock(_component_icon, {
            key: 0,
            icon: _ctx.icon,
            class: "input__wrapper__icon"
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        maxlength: _ctx.maxLength,
        minlength: _ctx.minLength,
        min: _ctx.min,
        max: _ctx.max,
        placeholder: _ctx.placeholder,
        type: _ctx.type,
        required: _ctx.required,
        disabled: _ctx.disabled,
        step: _ctx.step,
        class: "input__wrapper__value w-100"
      }, null, 8, _hoisted_2), [
        [_vModelDynamic, _ctx.value]
      ]),
      _createVNode(_component_icon, {
        class: "input__wrapper__icon input__wrapper__icon--error",
        icon: "exclamation-triangle"
      })
    ]),
    _createVNode(_Transition, { name: "pop" }, {
      default: _withCtx(() => [
        (_ctx.showError && _ctx.errors.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (e, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  class: "input__error_value"
                }, _toDisplayString(e), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 34))
}